import React from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../components/common/TitleSubtitle";
import styles from "../common/StudioHome.module.css";

const Support: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    return (
        <div className={styles.page}>
            <div className={styles.head}>
                <TitleSubtitle title={t("support")} subtitle={t("supportSubTitle")} />
            </div>
        </div>
    );
};

export default Support;
